var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_13168)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_65_13168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.96548 18.4096C6.07357 18.5177 6.2019 18.6035 6.34313 18.662C6.48436 18.7205 6.63574 18.7506 6.78861 18.7506C6.94148 18.7506 7.09285 18.7205 7.23409 18.662C7.37532 18.6035 7.50364 18.5177 7.61173 18.4096L12.375 13.6464L17.1382 18.4089C17.2456 18.5202 17.374 18.609 17.516 18.6702C17.658 18.7313 17.8108 18.7635 17.9655 18.765C18.1201 18.7664 18.2734 18.737 18.4166 18.6785C18.5597 18.62 18.6898 18.5336 18.7991 18.4243C18.9085 18.315 18.995 18.185 19.0535 18.0418C19.1121 17.8987 19.1416 17.7454 19.1402 17.5908C19.1388 17.4361 19.1067 17.2833 19.0456 17.1413C18.9845 16.9992 18.8958 16.8707 18.7845 16.7634L14.0212 12.0001L18.7837 7.23688C18.8951 7.12956 18.9839 7.00114 19.045 6.8591C19.1062 6.71707 19.1384 6.56429 19.1398 6.40966C19.1413 6.25504 19.1119 6.10168 19.0534 5.95854C18.9949 5.8154 18.9085 5.68534 18.7991 5.57598C18.6898 5.46661 18.5598 5.38012 18.4167 5.32156C18.2736 5.263 18.1202 5.23354 17.9656 5.23491C17.811 5.23627 17.6582 5.26843 17.5161 5.32951C17.3741 5.39058 17.2456 5.47935 17.1382 5.59063L12.375 10.3546L7.61173 5.59063C7.39333 5.37232 7.09714 5.24972 6.78834 5.24979C6.47954 5.24986 6.18341 5.3726 5.96511 5.591C5.7468 5.80941 5.6242 6.10559 5.62427 6.41439C5.62434 6.7232 5.74708 7.01932 5.96548 7.23763L10.7287 12.0001L5.96623 16.7634C5.85813 16.8715 5.77238 16.9998 5.71387 17.141C5.65536 17.2823 5.62525 17.4336 5.62525 17.5865C5.62525 17.7394 5.65536 17.8907 5.71387 18.032C5.77238 18.1732 5.85738 18.3015 5.96548 18.4096Z",
    fill: "#999999"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_13168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_65_13168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXMark);
export default __webpack_public_path__ + "static/media/x-mark.8a6e324b1b71ec56034cacd6ff282730.svg";
export { ForwardRef as ReactComponent };